<template>
  <div style="padding:14px 10px">
    <el-table style="width: 982px;margin-top:20px" size="small" :data="robss" highlight-current-row v-loading="loading"
      border element-loading-text="Loading...">
      <el-table-column prop="name" label="User" width="180" align="center">
      </el-table-column>
      <el-table-column prop="data" label="Detail" width="800">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import {
    smsRob,
  } from '../../api/apiFun'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        robss: [], //User数据
      }
    },
    created() {
      this.getdata()
    },
    methods: {
      removeBlock(str) {
        if (str) {
          var reg = /^{/gi
          var reg2 = /}$/gi
          str = str.replace(reg, '')
          str = str.replace(reg2, '')
          return str
        } else {
          return str
        }
      },
      // 获取Grab monitoring
      getdata() {
        this.loading = true
        smsRob().then(res => {
          this.loading = false
          if (res.code == 400) {
            this.$message({
              state: 'info',
              message: res.msg
            })
          } else {
            var robss = res.datas;
            robss.forEach(item => {
              var d = JSON.stringify(item.data).replace(/\{|}|"/g, '')
              var e = d.replace(/:/g, '：')
              item.data = e.replace(/,/g, '，')
            });
            this.robss = robss
          }
        }).catch(err => {
          this.loading = false
          this.$message.error('Failed to get grab monitoring, please try again later!')
        })
      },
      // Search事件
      search() {
        this.getdata(this.params)
      },
    }
  }

</script>

<style scoped>
  .el-image__error {
    font-size: 12px !important;
  }

  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/views/sms/sms_rob.vue